<script setup>
import emitter from "@/utils/bus"; // 通信对象
import { ref } from "vue";
import { setLocalStorage, getLocalStorage, appHapticFeedback } from "@/utils/common";
import closeIcon from "@/assets/icon/close.svg";
import { useConfigStore } from "@/store/config";
import { useRouter } from "vue-router";
let router = useRouter();

const config = useConfigStore();

let nowLanguage = ref("en");
let useLanguage = ref("");
let isShow = ref(false);
let nowLa = getLocalStorage("nowLanguage") ? getLocalStorage("nowLanguage") : "en"; // 尝试获取存储的数据
nowLanguage.value = nowLa;
useLanguage.value = nowLa;
let onchenge = (res) => {
  appHapticFeedback();
  nowLanguage.value = res;
};
let save = async () => {
  appHapticFeedback();
  emitter.emit("language", nowLanguage.value);
  setLocalStorage("nowLanguage", nowLanguage.value); // 本地存储语言信息
  useLanguage.value = useLanguage.value;
  //isShow.value = false;

  window.location.reload();
};

emitter.on("showLanguage", (res) => {
  nowLa = getLocalStorage("nowLanguage") ? getLocalStorage("nowLanguage") : "en"; // 尝试获取存储的数据
  nowLanguage.value = nowLa;
  useLanguage.value = nowLa;
  isShow.value = res;
});

let language = ref([
  // {
  //   id: "zh",
  //   icon: "cn",
  //   text: "中文",
  // },
  {
    id: "en",
    icon: "um",
    text: "English",
  },
  {
    id: "fa",
    icon: "ir",
    text: "فارسی",
  },
  {
    id: "ru",
    icon: "ru",
    text: "Русский язык",
  },
  {
    id: "id",
    icon: "id",
    text: "Bahasa Indonesia",
  },
  {
    id: "ar",
    icon: "arab",
    text: " العربية",
  },
  {
    id: "tr",
    icon: "tr",
    text: " Türkçe",
  },
  {
    id: "uk",
    icon: "ua",
    text: "Українська мова",
  },
  {
    id: "fr",
    icon: "fr",
    text: "Français",
  },
  {
    id: "es",
    icon: "es",
    text: "Español",
  },
  {
    id: "pt",
    icon: "pt",
    text: "Português",
  },
  {
    id: "hi",
    icon: "in",
    text: "हिंदी",
  },
  {
    id: "ko",
    icon: "kr",
    text: "한국어",
  },
  {
    id: "ja",
    icon: "jp",
    text: "日本語",
  },
  {
    id: "ur",
    icon: "pk",
    text: "اردو",
  },
  {
    id: "uz",
    icon: "uz",
    text: "O'zbekcha",
  },
  {
    id: "vi",
    icon: "vn",
    text: "Tiếng Việt",
  },
  {
    id: "pl",
    icon: "pl",
    text: "Polski",
  },
  {
    id: "fil",
    icon: "ph",
    text: "Filipino",
  },
  {
    id: "de",
    icon: "de",
    text: "Deutsch",
  },
  {
    id: "th",
    icon: "th",
    text: "ไทย",
  },
  {
    id: "bn",
    icon: "bd",
    text: "বাংলা",
  }
]);
if (import.meta.env.DEV) {
  language.value.push({
    id: "zh",
    icon: "cn",
    text: "中文",
  });
}
</script>

<template>
  <div class="view" v-show="isShow">
    <div class="language">
      <div class="top">
        <div>
          <div class="top_title">{{ $t("message.language") }}</div>
          <div class="top_introduced">{{ $t("message.Youcanchangethelanguagehere") }}</div>
        </div>
        <div class="close" @click="isShow = false">
          <img :src="closeIcon" alt="" />
        </div>
      </div>
      <div class="list">
        <div class="item" v-for="(item, index) in language" :key="index" @click="onchenge(item.id)">
          <div :class="'img ' + `fi-${item.icon}`"></div>
          <div>{{ item.text }}</div>
          <div v-show="useLanguage == item.id && nowLanguage != useLanguage">
            {{ $t("message.current") }}
          </div>
          <div v-show="nowLanguage == item.id">✓</div>
        </div>
      </div>
      <div class="button" :style="{ backgroundColor: config.themes_color }" @click="save">{{ $t("message.save") }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.view {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  backdrop-filter: blur(5px);

  .language {
    width: 90vw;
    margin: 0 auto;
    background: #ffffff;
    display: block;
    padding: 15px 10px;
    border-radius: 2vw;
    border: #e0e0e0 solid 1px;

    .button {
      width: 100%;
      height: 8vh;
      border-radius: 2vw;
      margin-top: 10px;
      text-align: center;
      line-height: 8vh;
      font-weight: bold;
      font-size: 20px;
      color: white;

      &:active {
        opacity: 0.5;
      }
    }

    .list {
      margin-top: 20px;
      overflow-y: auto;
      height: 38vh;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      padding: 0 10px;
      justify-content: space-between;

      .item {
        display: flex;
        padding: 8px;
        border-radius: 2vw;
        align-items: center;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        background: #f5f5f5;
        color: #333333;
        font-size: 14px;
        width: calc(50% - 4px);
        min-width: 0;

        div:nth-child(2) {
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          min-width: 0;
        }

        div:nth-child(3) {
          margin-right: 5px;
          font-size: 12px;
          flex-shrink: 0;
          color: #666666;
        }

        &>.img {
          width: 4vh;
          height: 4vh;
          margin-right: 8px;
          background-size: contain;
          background-position: 50%;
          background-repeat: no-repeat;
          flex-shrink: 0;
        }
      }
    }

    .top {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .close {
        width: 4vh;
        height: 4vh;

        img {
          width: 100%;
          height: 100%;
        }
      }

      &_title {
        font-weight: bold;
        font-size: 6vw;
        margin-bottom: 8px;
        color: #333333;
      }

      &_introduced {
        color: #666666;
        font-size: 3.5vw;
      }
    }
  }
}
</style>
